import { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import Footer from "../component/layout/footer";
import Header from "../component/layout/header";
import PageHeader from "../component/layout/pageheader";
import GroupSelect from "../component/sidebar/group-select";
import Pagination from "../component/sidebar/pagination";
import Rating from "../component/sidebar/rating";
import SkillSelect from "../component/sidebar/skill-select";

const courseList = [
    {
        imgUrl: 'assets/images/course/01.jpg',
        imgAlt: 'Drawing Course',
        price: '$30',
        cate: 'Drawing',
        reviewCount: '12 reviews',
        title: 'Beginner Pencil Drawing – Start Your Art Journey',
        totalLeson: '20 Lessons',
        schdule: 'Online Class',
        authorImgUrl: 'assets/images/course/author/01.jpg',
        authorImgAlt: 'Author',
        authorName: 'Arun Kumar',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/02.jpg',
        imgAlt: 'Painting Course',
        price: '$30',
        cate: 'Painting',
        reviewCount: '15 reviews',
        title: 'Watercolor Painting for Beginners and Artists',
        totalLeson: '22 Lessons',
        schdule: 'Online Class',
        authorImgUrl: 'assets/images/course/author/02.jpg',
        authorImgAlt: 'Author',
        authorName: 'Lora Smith',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/03.jpg',
        imgAlt: 'Digital Art Course',
        price: '$30',
        cate: 'Digital Art',
        reviewCount: '18 reviews',
        title: 'Learn Digital Art – Procreate & Tablet Drawing Basics',
        totalLeson: '25 Lessons',
        schdule: 'Online Class',
        authorImgUrl: 'assets/images/course/author/03.jpg',
        authorImgAlt: 'Author',
        authorName: 'Robot Smith',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/04.jpg',
        imgAlt: 'Vocal Course',
        price: '$30',
        cate: 'Vocal Music',
        reviewCount: '10 reviews',
        title: 'Vocal Training – Improve Your Voice & Singing Skills',
        totalLeson: '18 Lessons',
        schdule: 'Online Class',
        authorImgUrl: 'assets/images/course/author/04.jpg',
        authorImgAlt: 'Author',
        authorName: 'Zinat Zaara',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/05.jpg',
        imgAlt: 'Guitar Course',
        price: '$30',
        cate: 'Guitar',
        reviewCount: '20 reviews',
        title: 'Guitar Essentials – Chords, Rhythm & Songs',
        totalLeson: '30 Lessons',
        schdule: 'Online Class',
        authorImgUrl: 'assets/images/course/author/05.jpg',
        authorImgAlt: 'Author',
        authorName: 'Rajib Raj',
        btnText: 'Read More',
    },
    {
        imgUrl: 'assets/images/course/06.jpg',
        imgAlt: 'Piano Course',
        price: '$30',
        cate: 'Piano',
        reviewCount: '16 reviews',
        title: 'Piano for Beginners – Play Music in Weeks',
        totalLeson: '28 Lessons',
        schdule: 'Online Class',
        authorImgUrl: 'assets/images/course/author/06.jpg',
        authorImgAlt: 'Author',
        authorName: 'Angel Mili',
        btnText: 'Read More',
    },
];


const CoursePage = () => {
    return (
        <Fragment>
            <Header />
            <PageHeader title={'Art & Music Courses'} curPage={'Courses'} />
            <GroupSelect />

            <div className="course-section padding-tb section-bg">
                <div className="container">
                    <div className="section-wrapper">

                        <div className="course-showing-part">
                            <div className="d-flex flex-wrap align-items-center justify-content-between">
                                <div className="course-showing-part-left">
                                    <p>Showing 1-6 of 6 results</p>
                                </div>
                                <div className="course-showing-part-right d-flex flex-wrap align-items-center">
                                    <span>Sort by :</span>
                                    <div className="select-item">
                                        <SkillSelect select={'all'} />
                                        <div className="select-icon">
                                            <i className="icofont-rounded-down"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row g-4 justify-content-center row-cols-xl-3 row-cols-md-2 row-cols-1">
                            {courseList.map((val, i) => (
                                <div className="col" key={i}>
                                    <div className="course-item">
                                        <div className="course-inner">
                                            <div className="course-thumb">
                                                <img src={val.imgUrl} alt={val.imgAlt} />
                                            </div>
                                            <div className="course-content">
                                                <div className="course-price">{val.price}</div>

                                                <div className="course-category">
                                                    <div className="course-cate">
                                                        <a href="#">{val.cate}</a>
                                                    </div>
                                                    <div className="course-reiew">
                                                        <Rating />
                                                        <span className="ratting-count"> {val.reviewCount}</span>
                                                    </div>
                                                </div>

                                                <Link to=""><h4>{val.title}</h4></Link>

                                                {/* <div className="course-details">
                                                    <div className="couse-count"><i className="icofont-video-alt"></i> {val.totalLeson}</div>
                                                    <div className="couse-topic"><i className="icofont-signal"></i> {val.schdule}</div>
                                                </div> */}

                                                <div className="course-footer">
                                                    <div className="course-author">
                                                        <img src={val.authorImgUrl} alt={val.authorImgAlt} />
                                                        <Link to="" className="ca-name">{val.authorName}</Link>
                                                    </div>
                                                    <div className="course-btn">
                                                        <Link to="" className="lab-btn-text">
                                                            {val.btnText} <i className="icofont-external-link"></i>
                                                        </Link>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>

                        <Pagination />
                    </div>
                </div>
            </div>

            <Footer />
        </Fragment>
    );
}

export default CoursePage;
